import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteCrew: null,
  deleteCrewList: [],
};

const route = "modules/manage/modals/createEditManageCrew/redux/slice";

export const manageDeleteManageCrew = createAsyncThunk(
  "manage/deleteManageCrew/deleteManageCrew",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { id, items } = payload;
      if (id) {
        const data = await clientMutation(
          `mutation ($id: Int!){
              deleteCrew: deleteCrew(id: $id)
            }`,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteCrew) return data.deleteCrew;
        else throw "Error while deleting manage Crew";
      }
      if (items?.length) {
        items.forEach((manage, index) =>
          mutations.push(`deleteCrew${index}: deleteCrew(
                  id: ${manage.id}
              )`)
        );
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const data = await clientMutation(
          mutation,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteCrew0) return data.deleteCrew0;
        else throw "Error while deleting manage Crews";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Crew`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteCrew");
      rejectWithValue(exc);
    }
  }
);


const manageDeleteManageCrewRedux = createSlice({
    name: "manage/deleteManageCrew",
    initialState: INIT_STATE,
    reducers: {
      reset(state, action) {
        return action.payload
          ? { ...state, ...action.payload }
          : { ...INIT_STATE };
      },
      openModalDeleteManageCrew(state, action) {
        state.open = true;
        state.deleteCrew = action?.payload?.deleteCrew;
        state.deleteCrewList = action?.payload?.deleteCrewList;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(resetALL, () => INIT_STATE);
  
      //manageDeleteManageCrew
      builder.addCase(manageDeleteManageCrew.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(manageDeleteManageCrew.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
      builder.addCase(manageDeleteManageCrew.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    },
  });
  
  // Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageCrewRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageCrew } = actions;

// Export the reducer, either as a default or named export
export default reducer;
